'use client';

import styled from 'styled-components';

import { Button } from '@/elements/button/button.component';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  position: relative;

  width: 300px;
  min-width: 300px;
  min-height: 500px;
  height: calc(100% - 8px);
  padding: 36px 28px;
  gap: 28px;
  margin: 0 8px; //INFO: Margin jer ne radi slideGap u Carousel

  border-radius: 22px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: ${({ $selected }) => ($selected ? colors.dark : colors.light)};
  color: ${({ $selected }) => ($selected ? colors.light : colors.dark)};
  /* transform: ${({ $selected }) =>
    $selected
      ? `scale(1)`
      : `scale(0.9)`}; */ //INFO: Carousel ne daje dovoljno paddinga da se prikazuje scale, gleda samo width

  /* Premium layered shadow system for authentic depth */
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.04),
    0 4px 12px rgba(0, 0, 0, 0.05),
    0 16px 32px rgba(0, 0, 0, 0.04);

  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    cursor: ${({ $selected }) => ($selected ? 'default' : 'pointer')};
    transform: ${({ $selected }) => ($selected ? 'none' : 'translateY(-4px)')};
    box-shadow:
      0 2px 4px rgba(0, 0, 0, 0.05),
      0 8px 24px rgba(0, 0, 0, 0.08),
      0 24px 48px rgba(0, 0, 0, 0.06);
    border-color: rgba(0, 0, 0, 0.08);
  }
`;

export const TitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ $horizontal }) => ($horizontal ? 'flex-start' : 'center')};

  gap: 16px;
`;

export const Title = styled.div`
  width: ${({ $withRibbon }) => ($withRibbon ? '220px' : 'fit-content')};

  font-weight: 700;
  font-size: 1.5rem;
  white-space: nowrap;

  @media (max-width: ${breakpoints.tablet}) {
    white-space: normal;
  }
`;

export const Features = styled.div`
  display: flex;
  flex-direction: column;

  margin: auto 0;
  gap: 12px;
`;

export const Feature = styled.div`
  display: flex;
  align-items: center;

  gap: 8px;

  color: ${({ $has }) => ($has ? 'inherit' : colors.gray4)};
`;

export const Toggles = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: auto;
  gap: 24px;
`;

export const PriceData = styled.div`
  display: flex;
  flex-direction: ${({ $horizontal }) => ($horizontal ? 'row-reverse' : 'column')};
  justify-content: center;
  align-items: center;

  gap: 16px;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;

export const Price = styled.div`
  font-size: 2.4rem;
  letter-spacing: 1px;
  font-weight: 800;
`;

export const OldPrice = styled.div`
  display: flex;
  align-items: center;

  gap: 12px;

  ${Price} {
    font-size: 1.5rem;
    color: ${colors.silver};
  }
`;

export const CurrentPrice = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 8px;
`;

export const Discount = styled.div`
  font-size: 1.7rem;
  font-weight: 700;
  color: ${colors.tomato};
`;

export const ActionButton = styled(Button)``;

export const PriceAddition = styled.div`
  width: 48px;

  font-size: 1.1rem;
  font-weight: 600;

  color: ${colors.gray5};
`;
export const Ribbon = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  width: 150px;
  height: 150px;

  overflow: hidden;

  &::before,
  &::after {
    position: absolute;
    z-index: -1;
    content: '';
    display: block;
    border: 5px solid ${({ $color }) => colors[$color]};
  }
  & span {
    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    width: 225px;
    height: 52px;
    padding: 5px 15px 5px 23px;
    background-color: ${({ $color }) => colors[$color]};
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    color: #fff;
    font-weight: 700;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    text-transform: uppercase;
    text-align: center;
  }

  top: -9px;
  right: -9px;

  &::before,
  &::after {
    border-top-color: transparent;
    border-right-color: transparent;
  }
  &::before {
    top: 0;
    left: 0;
  }
  &::after {
    bottom: 0;
    right: 0;
  }
  & span {
    left: -26px;
    top: 27px;
    transform: rotate(45deg);
  }
`;

/* HorizontalContainer */
export const HorizontalContainer = styled.div`
  display: flex;

  position: relative;

  width: 100%;
  min-height: 210px;
  padding: 24px 28px;
  gap: 20%;

  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: ${colors.light};
  color: ${colors.dark};

  /* Premium layered shadow system for authentic depth */
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.04),
    0 4px 12px rgba(0, 0, 0, 0.05),
    0 16px 32px rgba(0, 0, 0, 0.04);

  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-4px);
    box-shadow:
      0 2px 4px rgba(0, 0, 0, 0.05),
      0 8px 24px rgba(0, 0, 0, 0.08),
      0 24px 48px rgba(0, 0, 0, 0.06);
    border-color: rgba(0, 0, 0, 0.08);
  }

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;

    gap: 32px;

    width: 300px;
    min-height: 400px;
    margin: 0 auto;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: ${breakpoints.tablet}) {
    gap: 16px;
  }
`;
